import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MusteriForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState({
    ad: '',
    temsilci: '',
    telefon: '',
    email: '',
    ulke: 'Türkiye',
    sehir: '',
    ilce: '',
    adres: '',
    vergi_dairesi: '',
    vergi_no: '',
    telefonlar: []
  });
  const [loading, setLoading] = useState(isEdit);

useEffect(() => {
const loadData = async () => {
    try {
      const citiesResponse = await axios.get(`${API}/cities`);
      setCities(citiesResponse.data);
      
      const countriesResponse = await axios.get(`${API}/countries`);
      setCountries(countriesResponse.data);
      
      if (isEdit) {
        const response = await axios.get(`${API}/musteriler/${id}`);
        const data = response.data;
        
        // Şehir adını cities listesiyle eşleştir (Türkçe karakter desteği)
        if (data.sehir) {
          const normalizeText = (text) => {
            return text
              .toLowerCase()
              .replace(/İ/g, 'i')
              .replace(/I/g, 'ı')
              .replace(/Ğ/g, 'ğ')
              .replace(/Ü/g, 'ü')
              .replace(/Ş/g, 'ş')
              .replace(/Ö/g, 'ö')
              .replace(/Ç/g, 'ç')
              .replace(/ı/g, 'i')
              .trim();
          };
          
          const normalizedSehir = normalizeText(data.sehir);
          
          const matchedCity = citiesResponse.data.find(c => 
            normalizeText(c) === normalizedSehir
          );
          
          if (matchedCity) {
            data.sehir = matchedCity;
          }
        }
        
        setFormData(data);
        setLoading(false);
      }
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
      setLoading(false);
    }
  };
  
  loadData();
}, [id, isEdit]);

  const fetchCities = async () => {
    try {
      const response = await axios.get(`${API}/cities`);
      setCities(response.data);
    } catch (error) {
      console.error('Şehirler yüklenirken hata:', error);
    }
  };

  const fetchMusteri = async () => {
  try {
    const response = await axios.get(`${API}/musteriler/${id}`);
    const data = response.data;
    
    // Şehir adını cities listesiyle eşleştir
    if (data.sehir && cities.length > 0) {
      const matchedCity = cities.find(c => 
        c.toLowerCase() === data.sehir.toLowerCase() ||
        c.toLowerCase().includes(data.sehir.toLowerCase()) ||
        data.sehir.toLowerCase().includes(c.toLowerCase())
      );
      if (matchedCity) {
        data.sehir = matchedCity;
      }
    }
    
    setFormData(data);
  } catch (error) {
    console.error('Müşteri yüklenirken hata:', error);
  } finally {
    setLoading(false);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await axios.put(`${API}/musteriler/${id}`, formData);
      } else {
        await axios.post(`${API}/musteriler`, formData);
      }
      navigate('/musteriler');
    } catch (error) {
      console.error('Müşteri kaydedilirken hata:', error);
      alert('Müşteri kaydedilemedi');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const addTelefon = () => {
    setFormData({
      ...formData,
      telefonlar: [...formData.telefonlar, { aciklama: '', numara: '' }]
    });
  };

  const removeTelefon = (index) => {
    const newTelefonlar = formData.telefonlar.filter((_, i) => i !== index);
    setFormData({ ...formData, telefonlar: newTelefonlar });
  };

  const updateTelefon = (index, field, value) => {
    const newTelefonlar = [...formData.telefonlar];
    newTelefonlar[index][field] = value;
    setFormData({ ...formData, telefonlar: newTelefonlar });
  };

  if (loading) {
    return <div className="loading" data-testid="loading">Yükleniyor...</div>;
  }

  return (
    <div data-testid="customer-form-page">
      <div className="page-header">
        <h1 className="page-title">{isEdit ? 'Müşteri Düzenle' : 'Yeni Müşteri'}</h1>
        <p className="page-subtitle">Müşteri bilgilerini giriniz</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="card">
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Müşteri Adı *</label>
              <input
                type="text"
                name="ad"
                className="form-input"
                value={formData.ad}
                onChange={handleChange}
                required
                data-testid="customer-name"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Temsilci</label>
              <input
                type="text"
                name="temsilci"
                className="form-input"
                value={formData.temsilci}
                onChange={handleChange}
                data-testid="customer-rep"
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Telefon</label>
              <input
                type="tel"
                name="telefon"
                className="form-input"
                value={formData.telefon}
                onChange={handleChange}
                data-testid="customer-phone"
              />
            </div>
            <div className="form-group">
              <label className="form-label">E-posta</label>
              <input
                type="email"
                name="email"
                className="form-input"
                value={formData.email}
                onChange={handleChange}
                data-testid="customer-email"
              />
            </div>
          </div>

          <div className="form-grid">
          <div className="form-group">
              <label className="form-label">Ülke</label>
              <select
                name="ulke"
                className="form-select"
                value={formData.ulke}
                onChange={handleChange}
                data-testid="customer-country"
              >
                <option value="">Ülke seçiniz</option>
                {countries.map(country => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Şehir</label>
              <select
                name="sehir"
                className="form-select"
                value={formData.sehir}
                onChange={handleChange}
                data-testid="customer-city"
              >
                <option value="">Şehir seçiniz</option>
                {cities.map(city => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">İlçe</label>
              <input
                type="text"
                name="ilce"
                className="form-input"
                value={formData.ilce}
                onChange={handleChange}
                data-testid="customer-district"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Adres</label>
            <textarea
              name="adres"
              className="form-textarea"
              value={formData.adres}
              onChange={handleChange}
              rows={3}
              data-testid="customer-address"
            />
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Vergi Dairesi</label>
              <input
                type="text"
                name="vergi_dairesi"
                className="form-input"
                value={formData.vergi_dairesi}
                onChange={handleChange}
                data-testid="customer-tax-office"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Vergi No</label>
              <input
                type="text"
                name="vergi_no"
                className="form-input"
                value={formData.vergi_no}
                onChange={handleChange}
                data-testid="customer-tax-no"
              />
            </div>
          </div>
        </div>

        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h3 style={{ margin: 0 }}>Ek Telefonlar</h3>
            <button type="button" className="btn btn-secondary" onClick={addTelefon} data-testid="add-phone-btn">
              + Telefon Ekle
            </button>
          </div>
          {formData.telefonlar.map((tel, index) => (
            <div key={index} style={{ display: 'flex', gap: '12px', marginBottom: '12px' }} data-testid={`phone-${index}`}>
              <input
                type="text"
                className="form-input"
                placeholder="Açıklama (örn: Muhasebe)"
                value={tel.aciklama}
                onChange={(e) => updateTelefon(index, 'aciklama', e.target.value)}
                style={{ flex: 1 }}
              />
              <input
                type="tel"
                className="form-input"
                placeholder="Telefon numarası"
                value={tel.numara}
                onChange={(e) => updateTelefon(index, 'numara', e.target.value)}
                style={{ flex: 1 }}
              />
              <button type="button" className="btn btn-danger" onClick={() => removeTelefon(index)}>
                Sil
              </button>
            </div>
          ))}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" data-testid="submit-btn">
            {isEdit ? 'Güncelle' : 'Kaydet'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/musteriler')} data-testid="cancel-btn">
            İptal
          </button>
        </div>
      </form>
    </div>
  );
};

export default MusteriForm;